export const CASHIER_ROLE = "cashier";
export const TRANSPORTER_ROLE = "transporter";
export const HOF_ROLE = "head of finance";
export const HOC_ROLE = "head cashier";
export const BROKER_ROLE = "broker";
export const DRIVER_ROLE = "driver";

export const SUPER_DISTRIBUTOR = "Super Distributor Admin User";
export const DISTRIBUTOR = "Distributor Admin User";
export const AGENT = "Agent User";
export const CLIENT = "Client Admin";
export const BROKER = "Broker User";
export const CUSTOMER = "Customer User";

export const APP_USERS = {
  SUPER_DISTRIBUTOR,
  DISTRIBUTOR,
  AGENT,
  CLIENT,
  BROKER,
  CUSTOMER,
};

export const APP_ROLES = {
  [SUPER_DISTRIBUTOR]: "Head of Finance",
  [DISTRIBUTOR]: "Head Cashier",
  [AGENT]: "Cashier",
  [CLIENT]: "Transporter",
  [BROKER]: "Broker",
  [CUSTOMER]: "Driver",
};
